import McException500 from './McException500';

export default McException500;
